import PaymentCard from '../../forms/Payment';
import centredForm from '../components/centredForm';

export default centredForm(PaymentCard, '', 350);



// WEBPACK FOOTER //
// ./src/view/scenes/Payment/PaymentMethod.js